import { useSelector } from '../index';

const useUserSelector = () => useSelector(({ user }) => user);

export const useUserLastLoginSelector = () => useSelector(({ user }) => user.lastLogin);

export const useUserRoleSelector = () => useSelector(({ user }) => user.role);
